import { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import classNames from '@/lib/misc/classNames';
interface Props {
  className?: string;
  value: string;
  tokenAmountToSend: string;
  onValueChange: (val: string, isSwitched: boolean) => void;
  isSwitched: boolean;
  disabled?: boolean;
}
const Number = ({
  value,
  onClick
}: {
  value: string | React.ReactNode;
  onClick: () => void;
}) => {
  const [isPressed, setIsPressed] = useState(false);
  return <div className={classNames('flex items-center justify-center text-genius-cream font-bold text-4xl w-1/3 py-3 px-4 transition-transform', isPressed ? 'scale-[0.75]' : 'scale-[1]')} onTouchStart={() => setIsPressed(true)} onTouchEnd={() => {
    setIsPressed(false);
    onClick();
  }} onTouchCancel={() => setIsPressed(false)} data-sentry-component="Number" data-sentry-source-file="NumberPad.tsx">
      {value}
    </div>;
};
export default function NumberPad({
  className,
  value,
  tokenAmountToSend,
  onValueChange,
  isSwitched,
  disabled
}: Props) {
  const handleClickNumPad = (pad: string) => {
    const currentValue = isSwitched ? tokenAmountToSend : value;
    if (pad === '.' && currentValue?.includes('.')) {
      return;
    }
    const newValue = currentValue === '0' && pad !== '.' ? pad : currentValue + pad;
    onValueChange(newValue, isSwitched);
  };
  const handleClickDelete = () => {
    const currentValue = isSwitched ? tokenAmountToSend : value;
    const newValue = currentValue.length === 1 ? '0' : currentValue.slice(0, -1);
    onValueChange(newValue, isSwitched);
  };
  return <div className={classNames('w-full flex flex-col transition-opacity px-2', disabled ? 'pointer-events-none opacity-50' : '', className)} data-sentry-component="NumberPad" data-sentry-source-file="NumberPad.tsx">
      <div className='w-full flex items-center gap-x-12'>
        <Number value='1' onClick={() => handleClickNumPad('1')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='2' onClick={() => handleClickNumPad('2')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='3' onClick={() => handleClickNumPad('3')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <Number value='4' onClick={() => handleClickNumPad('4')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='5' onClick={() => handleClickNumPad('5')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='6' onClick={() => handleClickNumPad('6')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <Number value='7' onClick={() => handleClickNumPad('7')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='8' onClick={() => handleClickNumPad('8')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='9' onClick={() => handleClickNumPad('9')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
      </div>
      <div className='w-full flex items-center gap-x-12'>
        <Number value='.' onClick={() => handleClickNumPad('.')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value='0' onClick={() => handleClickNumPad('0')} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
        <Number value={<FaArrowLeft />} onClick={() => handleClickDelete()} data-sentry-element="Number" data-sentry-source-file="NumberPad.tsx" />
      </div>
    </div>;
}